import { CartoonifyVariantProps } from 'common/Prose/nodeViews/Image/components/ImageVariant/Types'
import { ImageVariant } from 'common/Prose/nodeViews/Image/components/ImageVariant/ImageVariant'
import { useImageStore } from 'stores/ImageStore'
import { useCloudinary } from 'providers/CloudinaryProvider/CloudinaryProvider'
import { cartoonify } from '@cloudinary/url-gen/actions/effect'
import { SliderField } from './SliderField'

export const CartoonifyVariant = (props: CartoonifyVariantProps) => {
  const { variant } = props
  const imageStore = useImageStore()
  const cloudinary = useCloudinary()

  if (!cloudinary) return null

  return (
    <ImageVariant {...props}>
      <SliderField
        minValue={0}
        maxValue={100}
        step={1}
        initialValue={variant.qualifier || 50}
        label="Change cartoon effect level"
        onChangeEnd={(value) => {
          const image = cloudinary.image(variant.sourceUrl.split('?')[0]).setDeliveryType('fetch')
          image.effect(cartoonify(value))
          imageStore.clearVariants()
          imageStore.createVariant({ image, url: image.toURL(), action: 'cartoonify', qualifier: value })
        }}
      />
    </ImageVariant>
  )
}
